import { createContext, useContext, useState, useEffect } from 'react';

type Theme = 'light' | 'dark';

interface ThemeContextValue {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextValue>({
  theme: 'light',
  toggleTheme: () => {},
});

// eslint-disable-next-line react-refresh/only-export-components -- pattern Provider+hook : useTheme est inseparable du Provider. Le warning n'impacte que le HMR de ce fichier.
export function useTheme() {
  return useContext(ThemeContext);
}

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = useState<Theme>(() => {
    try {
      const stored = localStorage.getItem('serme-theme');
      return (stored === 'dark' || stored === 'light') ? stored : 'light';
    } catch {
      // localStorage indisponible (navigation privee stricte / quota) : defaut clair.
      return 'light';
    }
  });

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    try {
      localStorage.setItem('serme-theme', theme);
    } catch {
      // Ecriture impossible (navigation privee / quota) : le theme reste applique en memoire.
    }
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === 'light' ? 'dark' : 'light'));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
